import React from 'react'
import { MonitoreoYEvaluacion } from './MonitoreoYEvaluacion'
import { MonitoreoContextProvider } from '../../../context/MonitoreoContext'
import { MonitoringAndEvaluationProvider } from '../../../context/MonitoringAndEvaluationContext'
import { useLocation } from 'react-router-dom'

const FormMonitoreoYEvaluacion = () => {
  const location = useLocation()
  return (
    <>
      <MonitoringAndEvaluationProvider>
        <MonitoreoContextProvider>
          <MonitoreoYEvaluacion
            idForm={location.state.idForm}
            edit={location.state.edit}
          />
        </MonitoreoContextProvider>
      </MonitoringAndEvaluationProvider>
    </>
  )
}

export default FormMonitoreoYEvaluacion
